import React from "react";

function Footer() {
  return (
    <footer style={{ background: "#071c3b" }} className="text-white py-4 text-center">
      <div className="container">
        <p className="small mb-0">
          © 2026 Leocord Healthcare. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;